import { ARRAY_OF_CLIENTS_01 } from '../../mocks/clients.data';
import { IClient } from '../../interfaces';
import { IClientsService } from './clients.interface';
import { injectable } from 'inversify';
import { Observable, of } from 'rxjs';

@injectable()
export class ClientsMock implements IClientsService {

    clientObservable(): Observable<Array<IClient>> {
        return of(ARRAY_OF_CLIENTS_01);
    }
}
